<template>
  <div>
    <span v-if="dateHelper" style="display: none">
      {{ tanggal }} {{ value }}
    </span>
    <v-menu
      v-model="menuParent"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          ref="text_field"
          v-model="tanggal"
          :style="{
            fontSize: isMobile ? '8px' : '12px',
          }"
          style="border: none !important"
          v-bind="attrs"
          v-on="on"
          hide-details
          class="neon-date-input pa-0"
        >
          <template v-slot:prepend-inner>
            <v-icon
              :style="{
                fontSize: isMobile ? '16px' : '24px',
              }"
              style="text-align: center"
              color="cyan lighten-2"
              >mdi-calendar</v-icon
            >
          </template></v-text-field
        >
      </template>

      <!-- Date Picker -->
      <v-date-picker
        v-model="tanggal"
        @input="onInputDate"
        color="cyan"
        class="neon-date-picker"
        :header-color="'#0f2346'"
      ></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: ["value"],
  data() {
    return {
      dateHelper: true,
      menuParent: false,
      tanggal: this.value || "",
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
  },
  methods: {
    onInputDate() {
      this.menuParent = false;
      this.$emit("input", this.tanggal);
    },
  },
  watch: {
    value(newVal) {
      if (newVal !== this.tanggal) {
        this.tanggal = newVal;
      }
    },
  },
  mounted() {
    this.tanggal = this.value || "";
    setTimeout(() => {
      this.dateHelper = false;
    }, 200);
  },
};
</script>

<style scoped>
/* === Input Field === */
.neon-date-input .v-input__control {
  background-color: rgba(15, 35, 70, 0.7) !important;
  border-radius: 8px !important;
  border: 1px solid rgba(0, 255, 255, 0.4) !important;
  color: #00ffff !important;
  transition: all 0.3s ease;
}

.neon-date-input input {
  color: #00ffff !important;
}

.neon-date-input .v-icon {
  color: #00ffff !important;
}

.neon-date-input .v-label {
  color: rgba(0, 255, 255, 0.7) !important;
}

.neon-date-input .v-input__slot:hover {
  box-shadow: 0 0 10px rgba(0, 255, 255, 0.2);
}

/* === Popup Calendar === */
.neon-date-picker {
  background-color: rgba(5, 24, 45, 0.95) !important;
  border: 1px solid rgba(0, 255, 255, 0.3) !important;
  border-radius: 10px;
  box-shadow: 0 0 25px rgba(0, 255, 255, 0.15);
}

.neon-date-picker .v-date-picker-header {
  background-color: rgba(0, 255, 255, 0.08) !important;
  color: #00ffff !important;
}

.neon-date-picker .v-btn {
  color: #00ffff !important;
}

.neon-date-picker .v-btn--active {
  background-color: rgba(0, 255, 255, 0.2) !important;
}

.neon-date-picker .v-date-picker-title__date,
.neon-date-picker .v-date-picker-table {
  color: #00ffff !important;
}

.neon-date-picker .v-picker__title {
  background-color: rgba(15, 35, 70, 0.8) !important;
}

@media (max-width: 600px) {
  /* Paksa tinggi wrapper */
  ::v-deep .neon-date-input .v-input__slot {
    height: 28px !important;
    min-height: 28px !important;
  }

  /* Sesuaikan tinggi control container */
  ::v-deep .neon-date-input .v-input__control {
    min-height: 28px !important;
  }

  /* Atur posisi icon */
  ::v-deep .neon-date-input .v-input__prepend-inner {
    margin-top: 0 !important;
    height: 100%;
    display: flex;
    align-items: center; /* penting */
  }

  /* Atur input agar center */
  ::v-deep .neon-date-input input {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    height: 100% !important;
    display: flex;
    align-items: center;
  }
}
</style>
